import { closeModal } from "@/app/slices/modalSlice";
import { UploadOrShow } from "@/components/Shared/UploadOrShow";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { FieldLabel } from "@/components/ui/field";
import { Button } from "@/components/ui/button";
import { useDocumentUpload } from "@/hooks/useDocumentUpload";
import { RFIType } from "interfaces/enums";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

interface IFormValues {
  document_description: string;
  document_title: string;
  document_type: string;
  language: string;
  text_submission: string;
}

export const UploadDocumentModal = (props: {
  data: { destination_account_id: string };
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [files, setFiles] = useState<File[]>([]);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const callback = () => {
    handleCloseModal();
  };

  const { handleDocumentUpload, uploadingDocument } = useDocumentUpload();

  const form = useForm<IFormValues>({
    defaultValues: {
      document_title: "Invoice",
      document_description: "Invoice",
      document_type: RFIType.INVOICE,
      language: "es",
      text_submission: "",
    },
  });

  const onSubmit = (values: IFormValues) => {
    handleDocumentUpload({
      destination_account_id: props.data.destination_account_id,
      document_title: values.document_title,
      document_description: values.document_description,
      document_type: values.document_type,
      language: values.language,
      text_submission: values.text_submission?.trim(),
      files,
      callback,
    });
  };

  const handleDrop = (acceptedFiles: File[]) => {
    setFiles(acceptedFiles);
  };

  const handleDeleteFile = () => {
    setFiles([]);
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("Upload Document")}</DialogTitle>
        <DialogDescription>
          <form
            id="upload-document-form"
            onSubmit={form.handleSubmit(onSubmit)}
            className="flex flex-col gap-4 py-4"
          >
            {/* <Controller
              name="document_title"
              control={form.control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="document_title">
                    {t("Document Title")}
                  </FieldLabel>
                  <Input
                    {...field}
                    id="document_title"
                    className="font-normal"
                    placeholder={t("Enter document title")}
                    autoComplete="off"
                  />
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            /> */}

            {/* <Controller
              name="document_description"
              control={form.control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="document_description">
                    {t("Document Description")}
                  </FieldLabel>
                  <Textarea
                    {...field}
                    id="document_description"
                    className="font-normal"
                    placeholder={t("Enter document description")}
                  />
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            />

            <Controller
              name="document_type"
              control={form.control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="document_type">
                    {t("Document Type")}
                  </FieldLabel>
                  <Select onValueChange={field.onChange} value={field.value}>
                    <SelectTrigger id="document_type">
                      <SelectValue placeholder={t("Select document type")} />
                    </SelectTrigger>
                    <SelectContent>
                      {Object.keys(RFIType).map((type) => (
                        <SelectItem key={type} value={type}>
                          {t(type)}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            /> */}

            {/* <Controller
              name="language"
              control={form.control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="language">{t("Language")}</FieldLabel>
                  <Select onValueChange={field.onChange} value={field.value}>
                    <SelectTrigger id="language">
                      <SelectValue placeholder={t("Select language")} />
                    </SelectTrigger>
                    <SelectContent>
                      {["en", "es"].map((type) => (
                        <SelectItem key={type} value={type}>
                          {t(type)}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            /> */}

            {/* <Controller
              name="text_submission"
              control={form.control}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="text_submission">
                    {t("Text Submission (Optional)")}
                  </FieldLabel>
                  <Textarea
                    {...field}
                    id="text_submission"
                    className="font-normal"
                    placeholder={t("Enter additional text")}
                  />
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            /> */}

            <div className="mt-2">
              <FieldLabel>{t("File Upload")}</FieldLabel>
              <UploadOrShow
                category="document"
                doDrop={handleDrop}
                handleDelete={handleDeleteFile}
                isUploading={!!uploadingDocument}
                label={t("Drag-and-drop or click here to upload a file")}
                multiUpload={false}
                files={files.map((f) => ({
                  filename: f.name,
                  download: "",
                  category: "document",
                }))}
              />
            </div>

            <Button
              type="submit"
              className="mt-4"
              disabled={
                !!uploadingDocument ||
                !form.formState.isValid ||
                files.length === 0
              }
            >
              {t("Submit")}
            </Button>
          </form>
        </DialogDescription>
      </DialogHeader>
    </DialogContent>
  );
};

export default UploadDocumentModal;
